import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components'; // eslint-disable-next-line import/prefer-default-export

export function linkColorStyles() {
  return css(_templateObject(), function (_ref) {
    var theme = _ref.theme,
        active = _ref.active;
    return (// eslint-disable-next-line no-nested-ternary
      active ? theme.link.activeColor : theme.link.color
    );
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.link.hover.color;
  });
}
export function contrastLinkColorStyles() {
  return css(_templateObject2(), function (_ref3) {
    var theme = _ref3.theme,
        active = _ref3.active;
    return (// eslint-disable-next-line no-nested-ternary
      active ? theme.link.contrastActiveColor : theme.link.contrastColor
    );
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.link.hover.contrastColor;
  });
}